
import React, { useEffect, useState, useCallback } from 'react';

function TratamientosScreen({ token, tenant }) {
  const [tratamientos, setTratamientos] = useState([]);
  const [form, setForm] = useState({ nombre: '', carpeta: '', frameRate: 6, palabras: '', cantidadImagenes: 1, infoTexto: '', logotema: '', imagen_info: '' });
  const [fileInputs, setFileInputs] = useState({ logotema: null, imagen_info: null });
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [editFiles, setEditFiles] = useState({});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);


  const fetchTratamientos = useCallback(async () => {
    setLoading(true); setError('');
    try {
  const res = await fetch(`https://api.braineka.com/tratamientos?tenant_id=${tenant.id}`, {
        headers: { Authorization: 'Bearer ' + token }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al cargar tratamientos');
      setTratamientos(data);
    } catch (err) { setError(err.message); } finally { setLoading(false); }
  }, [tenant, token]);

  useEffect(() => { fetchTratamientos(); }, [fetchTratamientos]);



  const handleInput = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const handleFile = e => setFileInputs(f => ({ ...f, [e.target.name]: e.target.files[0] }));

  const handleCreate = async e => {
    e.preventDefault(); setError('');
    let logotemaUrl = '', imagenInfoUrl = '';
    // Subir archivos si hay
    if (fileInputs.logotema || fileInputs.imagen_info) {
      const fd = new FormData();
      fd.append('tenant_id', tenant.id);
      fd.append('carpeta', form.carpeta);
      if (fileInputs.logotema) fd.append('logotema', fileInputs.logotema);
      if (fileInputs.imagen_info) fd.append('imagen_info', fileInputs.imagen_info);
  const res = await fetch('https://api.braineka.com/upload', {
        method: 'POST', headers: { Authorization: 'Bearer ' + token }, body: fd
      });
      const data = await res.json();
      if (data.logotema) logotemaUrl = data.logotema;
      if (data.imagen_info) imagenInfoUrl = data.imagen_info;
    }
    // Crear tratamiento
    try {
  const res = await fetch('https://api.braineka.com/tratamientos', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({
          tenant_id: tenant.id,
          nombre: form.nombre,
          carpeta: form.carpeta,
          frameRate: Number(form.frameRate),
          palabras: form.palabras.split(',').map(p => p.trim()),
          cantidadImagenes: Number(form.cantidadImagenes),
          infoTexto: form.infoTexto,
          logotema: logotemaUrl,
          imagen_info: imagenInfoUrl
        })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al crear tratamiento');
      setForm({ nombre: '', carpeta: '', frameRate: 6, palabras: '', cantidadImagenes: 1, infoTexto: '', logotema: '', imagen_info: '' });
      setFileInputs({ logotema: null, imagen_info: null });
      fetchTratamientos();
    } catch (err) { setError(err.message); }
  };

  const handleDelete = async id => {
    if (!window.confirm('¿Eliminar este tratamiento?')) return;
    setError('');
    try {
  const res = await fetch(`https://api.braineka.com/tratamientos/${id}`, {
        method: 'DELETE', headers: { Authorization: 'Bearer ' + token }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al eliminar');
      fetchTratamientos();
    } catch (err) { setError(err.message); }
  };

  const startEdit = t => {
    setEditId(t.id);
    setEditForm({ ...t, palabras: t.palabras ? JSON.parse(t.palabras).join(', ') : '' });
    setEditFiles({});
  };
  const handleEditInput = e => setEditForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const handleEditFile = e => setEditFiles(f => ({ ...f, [e.target.name]: e.target.files[0] }));

  const handleEditSave = async e => {
    e.preventDefault(); setError('');
    let logotemaUrl = editForm.logotema, imagenInfoUrl = editForm.imagen_info;
    // Subir archivos si hay
    if (editFiles.logotema || editFiles.imagen_info) {
      const fd = new FormData();
      fd.append('tenant_id', tenant.id);
      fd.append('carpeta', editForm.carpeta);
      if (editFiles.logotema) fd.append('logotema', editFiles.logotema);
      if (editFiles.imagen_info) fd.append('imagen_info', editFiles.imagen_info);
  const res = await fetch('https://api.braineka.com/upload', {
        method: 'POST', headers: { Authorization: 'Bearer ' + token }, body: fd
      });
      const data = await res.json();
      if (data.logotema) logotemaUrl = data.logotema;
      if (data.imagen_info) imagenInfoUrl = data.imagen_info;
    }
    // Guardar edición
    try {
  const res = await fetch(`https://api.braineka.com/tratamientos/${editId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({
          tenant_id: tenant.id,
          nombre: editForm.nombre,
          carpeta: editForm.carpeta,
          frameRate: Number(editForm.frameRate),
          palabras: editForm.palabras.split(',').map(p => p.trim()),
          cantidadImagenes: Number(editForm.cantidadImagenes),
          infoTexto: editForm.infoTexto,
          logotema: logotemaUrl,
          imagen_info: imagenInfoUrl
        })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al editar tratamiento');
      setEditId(null); setEditForm({}); setEditFiles({});
      fetchTratamientos();
    } catch (err) { setError(err.message); }
  };
  const handleEditCancel = () => { setEditId(null); setEditForm({}); setEditFiles({}); };

  return (
    <div className="tratamientos-container">
      <h3>Tratamientos de {tenant.nombre}</h3>
      <form onSubmit={handleCreate} className="tratamiento-form">
        <input name="nombre" value={form.nombre} onChange={handleInput} placeholder="Nombre" required />
        <input name="carpeta" value={form.carpeta} onChange={handleInput} placeholder="Carpeta" required />
        <input name="frameRate" type="number" value={form.frameRate} onChange={handleInput} placeholder="Frame rate" min={1} required />
        <input name="palabras" value={form.palabras} onChange={handleInput} placeholder="Palabras (separadas por coma)" required />
        <input name="cantidadImagenes" type="number" value={form.cantidadImagenes} onChange={handleInput} placeholder="Cantidad imágenes" min={1} required />
        <textarea name="infoTexto" value={form.infoTexto} onChange={handleInput} placeholder="Texto info" />
        <label>Logotema: <input name="logotema" type="file" accept="image/*" onChange={handleFile} /></label>
        <label>Imagen info: <input name="imagen_info" type="file" accept="image/*" onChange={handleFile} /></label>
        <button type="submit">Crear tratamiento</button>
      </form>
      {error && <div className="tratamiento-error">{error}</div>}
      {loading ? <div>Cargando...</div> : (
        <table className="tratamiento-table">
          <thead>
            <tr>
              <th>Nombre</th><th>Carpeta</th><th>FrameRate</th><th>Palabras</th><th>Imágenes</th><th>Info</th><th>Logotema</th><th>Imagen info</th><th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {tratamientos.map(t => editId === t.id ? (
              <tr key={t.id}>
                <td><input name="nombre" value={editForm.nombre} onChange={handleEditInput} /></td>
                <td><input name="carpeta" value={editForm.carpeta} onChange={handleEditInput} /></td>
                <td><input name="frameRate" type="number" value={editForm.frameRate} onChange={handleEditInput} /></td>
                <td><input name="palabras" value={editForm.palabras} onChange={handleEditInput} /></td>
                <td><input name="cantidadImagenes" type="number" value={editForm.cantidadImagenes} onChange={handleEditInput} /></td>
                <td><textarea name="infoTexto" value={editForm.infoTexto} onChange={handleEditInput} /></td>
                <td>
                  {editForm.logotema && <img src={editForm.logotema} alt="logotema" style={{ maxWidth: 40 }} />}
                  <input name="logotema" type="file" accept="image/*" onChange={handleEditFile} />
                </td>
                <td>
                  {editForm.imagen_info && <img src={editForm.imagen_info} alt="info" style={{ maxWidth: 40 }} />}
                  <input name="imagen_info" type="file" accept="image/*" onChange={handleEditFile} />
                </td>
                <td>
                  <button onClick={handleEditSave}>Guardar</button>
                  <button onClick={handleEditCancel}>Cancelar</button>
                </td>
              </tr>
            ) : (
              <tr key={t.id}>
                <td>{t.nombre}</td>
                <td>{t.carpeta}</td>
                <td>{t.frameRate}</td>
                <td>{t.palabras && JSON.parse(t.palabras).join(', ')}</td>
                <td>{t.cantidadImagenes}</td>
                <td>{t.infoTexto}</td>
                <td>{t.logotema && <img src={t.logotema} alt="logotema" style={{ maxWidth: 40 }} />}</td>
                <td>{t.imagen_info && <img src={t.imagen_info} alt="info" style={{ maxWidth: 40 }} />}</td>
                <td>
                  <button onClick={() => startEdit(t)}>Editar</button>
                  <button onClick={() => handleDelete(t.id)}>Eliminar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default TratamientosScreen;
